import React from 'react'
import Header from '../components/Header'
import Footer from '../components/Footer'
import BreadCrumbs from "../components/BreadCrumbs"
import FilterReportSubs from "../components/FilterReportSubs"


const Reports = () => {

    return <div className="pageReports">
        <Header/>
        <BreadCrumbs title={'Отчёт'} />
        <FilterReportSubs />
        <div className="pageReportsContent">
            <div className="pageReportsContent__spacer" />
        </div>
        <Footer/>
    </div>
}

export default Reports

